import { useState } from "react";
import { toast } from "sonner";
import { CalendarPlus, Download, Link2 } from "lucide-react";
import { kfetch } from "@/components/kunden/AppointmentCard";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const btn = "flex items-center justify-center gap-2 h-11 px-3 border border-white/20 text-sm text-white hover:border-[#c1ff72]";

export default function CalendarExport() {
  const [link, setLink] = useState(null);
  const subscribe = async (renew = false) => {
    try { setLink(await kfetch(`/calendar/link${renew ? "?renew=true" : ""}`, { method: "POST" })); } catch (e) { toast.error(e.message); }
  };
  const copy = () => {
    const fallback = () => { window.prompt("Link kopieren:", link.url); };
    if (!navigator.clipboard) return fallback();
    navigator.clipboard.writeText(link.url).then(() => toast.success("Link kopiert")).catch(fallback);
  };
  return (
    <div className="space-y-2" data-testid="calendar-export">
      <p className="text-sm text-white font-semibold flex items-center gap-2"><CalendarPlus className="w-4 h-4 text-[#c1ff72]" />Termine in deinen Kalender</p>
      <div className="grid sm:grid-cols-2 gap-2">
        <a href={`${API_URL}/api/kunden/calendar/download.ics`} className={btn} data-testid="calendar-download"><Download className="w-4 h-4" />Kalenderdatei (.ics)</a>
        <button type="button" onClick={() => subscribe()} className={btn} data-testid="calendar-subscribe"><Link2 className="w-4 h-4" />Kalender abonnieren</button>
      </div>
      {link && <div className="border border-white/10 p-3 space-y-2 text-sm" data-testid="calendar-links">
        <p className="text-[#A1A1AA]">Abonnierte Kalender aktualisieren sich automatisch – auch bei Verschiebungen und Stornierungen.</p>
        <div className="grid sm:grid-cols-3 gap-2">
          <a href={link.webcal} className={btn} data-testid="calendar-apple">Apple / Outlook</a>
          <a href={link.google} target="_blank" rel="noreferrer" className={btn} data-testid="calendar-google">Google Kalender</a>
          <button type="button" onClick={copy} className={btn} data-testid="calendar-copy">Link kopieren</button>
        </div>
        <button type="button" onClick={() => subscribe(true)} className="text-xs text-[#71717A] underline" data-testid="calendar-renew">Link neu erzeugen (alter Link wird ungültig)</button>
      </div>}
    </div>
  );
}
